import { ClienteRepository } from "../repository/cliente_repository";

export class ClienteService {
	constructor() {
		this.clienteRepository = new ClienteRepository();
	}

	async save(data) {
		return await this.clienteRepository.save(data);
	}

	async update(data) {
		return await this.clienteRepository.update(data);
	}

	async getAll(unidadeDistribuidoraId, page, limit, search) {
		return await this.clienteRepository.getAll(unidadeDistribuidoraId, page, limit, search);
	}

	async getById(id) {
		return await this.clienteRepository.getById(id);
	}

	async changeVisibility(id) {
		return await this.clienteRepository.changeVisibility(id);
	}
}
